module.exports = __webpack_public_path__ + "static/media/Oxford-Park-By-Laws.62dfa71e.pdf";